import { EditGridColumnType } from "../../../../components/FinalMolGrid/libs/data/editGridColumnType";
import { GridColumnType } from "../../../../components/FinalMolGrid/libs/data/gridColumnType";

export const DropdownListConfig = {
    columns: [
        {
            name: "Dropdown Name",
            fieldName: "name",
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.INPUT,
                placeholder: "test",
                editColFieldName: "name",
                isDisable: false,
                colConfig: {
                    // maxLength: 5,
                    isReadOnly: false,
                },
                editColValidation: [
                    { type: "required", message: "Dropdown name is required." },
                ],
            },
            colStyle: {
                width: "30%",
                textAlign: "center",
            },
            allowShort: false
        },
        {
            name: "Value Order",
            fieldName: "valueOrdering",
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.INPUT,
                placeholder: "test",
                editColFieldName: "valueOrdering",
                isDisable: false,
                colConfig: {
                    maxLength: 5,
                    isReadOnly: false,
                },
                editColValidation: [
                    { type: "required", message: "Value Order is required." },
                ],
            },
            colStyle: {
                width: "30%",
                textAlign: "center",
            },
            allowShort: false
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            },
            allowShort: false
        },
    ],
    editSettings: {
        buttons: {
            save: true,
            cancel: true
        }
    },
    allowEdit: true,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
};